module.exports = __webpack_public_path__ + "img/SQLogo.af2d4bc8.png";